// src/providers/AuthContext.jsx
import React, { useState, useEffect, useContext } from "react";
import i18n from "../i18n";
import { getProfile } from "../api/profile";

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

function parseJwt(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(base64));
    return payload;
  } catch (e) {
    console.error("Невірний токен", e);
    return null;
  }
}

export function AuthProvider({ children }) {
  const [token, setToken] = useState(null);
  const [userName, setUserName] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isCompanyAdmin, setIsCompanyAdmin] = useState(
    () => localStorage.getItem("is_company_admin") === "1"
  );

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    const storedUserName = localStorage.getItem("user_name");

    if (storedToken) {
      const payload = parseJwt(storedToken);
      const isExpired = !payload?.exp || payload.exp * 1000 < Date.now();

      if (isExpired) {
        localStorage.removeItem("token");
        localStorage.removeItem("user_name");
        localStorage.removeItem("is_company_admin");
      } else {
        setToken(storedToken);
        setIsLoggedIn(true);
        if (storedUserName) setUserName(storedUserName);
      }
    }
  }, []);

  const login = async (newToken) => {
    const payload = parseJwt(newToken);
    const fullName = payload?.full_name || "";

    localStorage.setItem("token", newToken);
    localStorage.setItem("user_name", fullName);

    setToken(newToken);
    setUserName(fullName);
    setIsLoggedIn(true);

    // Sync language preference from DB
    try {
      const data = await getProfile();
      if (data.user?.language) {
        i18n.changeLanguage(data.user.language);
      }
    } catch (e) {
      // silent — language stays as localStorage/default
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user_name");
    localStorage.removeItem("is_company_admin");

    setToken(null);
    setUserName(null);
    setIsLoggedIn(false);
    setIsCompanyAdmin(false);
  };

  const updateIsCompanyAdmin = (val) => {
    localStorage.setItem("is_company_admin", val ? "1" : "0");
    setIsCompanyAdmin(val);
  };

  const updateUserName = (newName) => {
    localStorage.setItem("user_name", newName);
    setUserName(newName);
  };

  return (
    <AuthContext.Provider value={{ token, userName, isLoggedIn, isCompanyAdmin, updateIsCompanyAdmin, login, logout, updateUserName }}>
      {children}
    </AuthContext.Provider>
  );
}
